module.exports = __webpack_public_path__ + "assets/img/img-banner-home.5b7f8dbf.png";